// Delivery Guidelines and Safety Rules
export const safetyRules = [
  {
    id: 'mailbox',
    title: 'Never touch mailboxes',
    description: 'Never drop a flyer in a mailbox. Tampering with a mailbox is a federal crime.',
    category: 'legal',
    severity: 'critical'
  },
  {
    id: 'windshield',
    title: 'No windshield flyers in residential areas',
    description: 'Never hand out a brochure on a car windshield in a neighborhood or residential zone.',
    category: 'delivery',
    severity: 'high'
  },
  {
    id: 'public_toilet',
    title: 'No public restroom use',
    description: 'Never use the toilet in public.',
    category: 'conduct',
    severity: 'high'
  },
  {
    id: 'dropped_brochures',
    title: 'Pick up dropped materials',
    description: "Never drop brochures. If you accidentally drop them, be sure to pick them up so the customer doesn't blame you for throwing them away.",
    category: 'delivery',
    severity: 'high'
  },
  {
    id: 'waste_materials',
    title: 'Never throw away materials',
    description: "Each brochure costs money to print. Never throw them away. The client will cancel the job and expect you to pay for the lost brochures.",
    category: 'delivery',
    severity: 'critical'
  },
  {
    id: 'mail_packages',
    title: 'Never touch mail packages',
    description: 'Never touch a FedEx, UPS, or USPS mail package at someone\'s house or front door. Tampering with someone\'s mail is a federal crime.',
    category: 'legal',
    severity: 'critical'
  },
  {
    id: 'property_items',
    title: 'Never take items from properties',
    description: 'Never pick up or take items or trash from a house or front yard.',
    category: 'conduct',
    severity: 'high'
  },
  {
    id: 'single_leaflet',
    title: 'One leaflet per door',
    description: 'Never hang more than 1 leaflet on a door.',
    category: 'delivery',
    severity: 'medium'
  },
  {
    id: 'safety_vest',
    title: 'Wear reflective safety vest',
    description: 'All walkers must wear a reflective safety vest at all times while working.',
    category: 'safety',
    severity: 'critical'
  }
];

export const safetyWarning = {
  termination: "Breaking any of these rules will result in the automatic termination of your contract!",
  vestRequired: "All walkers MUST wear a reflective safety jacket at all times while working.",
  hazardProtocol: "IMPORTANT: If you do not feel safe for any reason, or if a house or car does not seem safe, or if there is an animal or ANY other form of hazard while you are working, DO NOT HAND OVER. Take a picture of the hazard. Skip the house or street. Report the incident to your driver or manager."
};
